import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { Icon } from '../Icon/Icon';
import { Portal } from '../Portal/Portal';

import styles from './Popup.module.scss';

export type PopupProps = {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  testID?: string;
  shouldRenderCloseIconButton?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  children?: ReactNode;
  showHeader?: boolean;
  overlayClassname?: string;
  bodyClassname?: string;
  withoutPortal?: boolean;
};

export const Popup: FC<PopupProps> = ({
  isOpen,
  onClose,
  className,
  testID,
  shouldRenderCloseIconButton = true,
  shouldCloseOnOverlayClick = true,
  showHeader = true,
  children,
  overlayClassname,
  bodyClassname,
  withoutPortal = false,
}) => {
  if (!isOpen) return null;

  const renderPopup = (
    <div
      className={cn(
        styles.popup,
        withoutPortal && styles.popupWithoutPortal,
        className,
      )}
      data-testid={testID}
    >
      <div
        className={cn(styles.overlay, overlayClassname)}
        {...(shouldCloseOnOverlayClick ? { onClick: onClose } : {})}
      />
      <div className={styles.container}>
        {showHeader && (
          <header
            className={cn(
              styles.header,
              shouldRenderCloseIconButton && styles.rowReverse,
            )}
          >
            {shouldRenderCloseIconButton && (
              <Icon
                className={styles.crossBtn}
                name="close"
                size={40}
                onClick={onClose}
              />
            )}
          </header>
        )}

        <div className={cn(styles.popupBody, bodyClassname)}>{children}</div>
      </div>
    </div>
  );

  return withoutPortal ? renderPopup : <Portal>{renderPopup}</Portal>;
};
